import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import Image404 from '../../img/404/not_found.png'

export default class TourNotActive extends PureComponent {
  render () {
    return (
        <div className='not-found'>
          <div className='not-found__content'>
            <img className="not-found__image" src={Image404} alt="not_found"/>
            <p className='not-found__Heading'>Well, this is awkward...</p>
            <h3 className='not-found__info'>To experience the tour please follow the link below!</h3>
            <Link className='btn btn-primary' to='/app/getting-started'>
            Getting Started </Link>
          </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/tour/TourNotActive.js